<template>
  <div style="margin: 20px">
    <h1>Авторизация администратора</h1>
    <div v-if="isAdmin">
      <p>Вы уже авторизованы как администратор.</p>
    </div>
    <div v-else>
      <p>Авторизация как администратор...</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isAdmin() {
      return localStorage.getItem('isAdmin') === 'true';
    }
  },
  created() {
    if (!this.isAdmin) {
      localStorage.setItem('isAdmin', 'true');
    }
  }
}
</script>
